module.exports = __webpack_public_path__ + "img/logo-img.92032492.png";